/*
 *
 * MyAccount actions
 *
 */

import {
  GET_USER_WATCHER,
  GET_USER_SUCCESS,
  GET_USER_FAILED,
  GET_LANGUAGE_WATCHER,
  GET_LANGUAGE_SUCCESS,
  GET_LANGUAGE_FAILED,
  PUT_USER_WATCHER,
  PUT_USER_SUCCESS,
  PUT_USER_FAILED,
  PUT_LANGUAGE_WATCHER,
  PUT_LANGUAGE_SUCCESS,
  PUT_LANGUAGE_FAILED,
  PASSWORD_USER_WATCHER,
  PASSWORD_USER_SUCCESS,
  PASSWORD_USER_FAILED,
} from "./constants"

export function getLanguageWatcher(payload) {
  return {
    type: GET_LANGUAGE_WATCHER,
    payload,
  }
}

export function getLanguageSuccess(payload) {
  return {
    type: GET_LANGUAGE_SUCCESS,
    payload,
  }
}

export function getLanguageFailed(payload) {
  return {
    type: GET_LANGUAGE_FAILED,
    payload,
  }
}

export function putLanguageWatcher(payload) {
  return {
    type: PUT_LANGUAGE_WATCHER,
    payload,
  }
}

export function putLanguageSuccess(payload) {
  return {
    type: PUT_LANGUAGE_SUCCESS,
    payload,
  }
}

export function putLanguageFailed(payload) {
  return {
    type: PUT_LANGUAGE_FAILED,
    payload,
  }
}

export function passwordUserWatcher(payload) {
  return {
    type: PASSWORD_USER_WATCHER,
    payload,
  }
}

export function passwordUserSuccess(payload) {
  return {
    type: PASSWORD_USER_SUCCESS,
    payload,
  }
}

export function passwordUserFailed(payload) {
  return {
    type: PASSWORD_USER_FAILED,
    payload,
  }
}

export function putUserWatcher(payload) {
  return {
    type: PUT_USER_WATCHER,
    payload,
  }
}

export function putUserSuccess(payload) {
  return {
    type: PUT_USER_SUCCESS,
    payload,
  }
}

export function putUserFailed(payload) {
  return {
    type: PUT_USER_FAILED,
    payload,
  }
}

export function getUserWatcher(payload) {
  return {
    type: GET_USER_WATCHER,
    payload,
  }
}

export function getUserSuccess(payload) {
  return {
    type: GET_USER_SUCCESS,
    payload,
  }
}

export function getUserFailed(payload) {
  return {
    type: GET_USER_FAILED,
    payload,
  }
}
